module.exports = __webpack_public_path__ + "img/payment-pic-08.583abd4a.png";